import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Spinner, Button, useDisclosure } from "@heroui/react";
import { addToast } from "@heroui/react";
import { getUserToken } from 'src/shared/utils/session';
import { useAcceptTeamInviteMutation } from "src/services/rtk_api/team/TeamsApi";
import LoginModal from "src/shared/components/LoginModal";

export default function JoinTeamPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get("token");
  const [acceptInvite, { isLoading }] = useAcceptTeamInviteMutation();

  const [modalMode, setModalMode] = useState("LOGIN");
  const {
    isOpen: isModalOpen,
    onOpen: onModalOpen,
    onOpenChange: onModalOpenChange,
  } = useDisclosure();

  const handleInvite = async () => {
    if (!token) {
      addToast({
        title: "Invalid or missing invitation token.",
        severity: "danger",
        color: "danger"
      });
      return;
    }

    try {
      const res = await acceptInvite({ token }).unwrap();
      addToast({
        title: res.message || "You have successfully joined the team!",
        severity: "success",
        color: "success"
      });
      setTimeout(() => {
        window.location.href = "/account/teams"
      }, 1500)
    } catch (err) {
      const errorMsg = err?.data?.error || "Failed to accept invitation.";
      addToast({
        title: errorMsg,
        severity: "danger",
        color: "danger"
      });
      setTimeout(() => navigate("/"), 2000);
    }
  };

  useEffect(() => {
    let handled = false;

    const processInvite = async () => {
      if (handled) return;
      handled = true;

      const isLoggedIn = !!getUserToken();
      if (!isLoggedIn) {
        setModalMode("LOGIN");
        onModalOpen();
      } else {
        await handleInvite();
      }
    };

    processInvite();
  }, [token]);

  const handleLoginSuccess = () => {
    onModalOpenChange(false);
    handleInvite();
  };

  const handleModalChange = (open) => {
    onModalOpenChange(open);
    if (!open) navigate("/"); 
  };

  return (
    <div className="flex flex-col items-center justify-center h-screen text-center">
      {isLoading ? (
        <>
          <Spinner label="Accepting your invite..." />
          <p className="text-gray-500 mt-4">Please wait...</p>
        </>
      ) : (
        <>
          <h1 className="text-2xl font-semibold mb-4">Processing Invitation...</h1>
          <p className="text-gray-500 mb-6">You’ll be redirected shortly.</p>
          <Button color="primary" onPress={() => navigate("/account/teams")}>
            Go to My Team
          </Button>
        </>
      )}

      <LoginModal
        mode={modalMode}
        isOpen={isModalOpen}
        onOpenChange={handleModalChange}
        onOk={handleLoginSuccess}
      />
    </div>
  );
}
